// extracted by mini-css-extract-plugin
export default {"innerTitlebox":"postjob_innerTitlebox__vDb7w","cardPostJobBox":"postjob_cardPostJobBox__fW0ir","navItemli":"postjob_navItemli__ucXgj","navText":"postjob_navText__xvlEz"};